export { XpGainFlash } from './XpGainFlash';
export type { XpGainFlashProps } from './XpGainFlash';
